import gql from "graphql-tag";

export const USER_ACTIVITIES_QUERY = gql`
  query activitiesQuery($userId: ID, $startDate: Date, $endDate: Date) {
    workoutBlockWorkoutLogs(subscriptionBlock_UserId: $userId, startDate_Lte: $endDate, startDate_Gte: $startDate) {
      edges {
        node {
          id
          image
          calories
          heartRate
          effort
          comment
          startDate
          createdAt
          coachComment
          type {
            id
            name
          }
          subscriptionBlock {
            id
            block {
              id
              title
            }
          }
          unitActivity {
            id
            type
            activity {
              id
              title
            }
          }
        }
      }
    }
    actions(date_Lte: $endDate, date_Gte: $startDate, userProgram_UserId: $userId) {
      edges {
        node {
          id
          date
          createdAt
          workout {
            id
            label
          }
        }
      }
    }
    restDays(restDayDate_Lte: $endDate, restDayDate_Gte: $startDate, userId: $userId) {
      edges {
        node {
          id
          didRest
          restDayDate
          planned
          details
          createdAt
          coachComment
        }
      }
    }
    activities(startDate_Lte: $endDate, startDate_Gte: $startDate, userId: $userId) {
      edges {
        node {
          id
          effort
          calories
          heartRate
          startDate
          seconds
          distance
          isCustom
          activityType
          comment
          createdAt
          image
          coachComment
          type {
            id
            name
            category
          }
          guidedRun {
            id
            name
            published
          }
          event {
            id
            name
            eventType {
              id
              name
              category
            }
          }
          action {
            workout {
              id
              name
              label
              workoutProgram {
                id
              }
            }
          }
          workout {
            id
            name
            label
            workoutProgram {
              id
            }
          }
        }
      }
    }
  }
`;
